class ProductsSlider extends HTMLElement {
  static observedAttributes = ["data-active-block-index"];

  constructor() {
    super();
    this.selectors = {
      swiper: "[js-swiper]",
      swiperSlide: "[js-swiper-slide]",
      swiperNextEl: "[js-swiper-next-button]",
      swiperPrevEl: "[js-swiper-prev-button]",
    };

    this.attrs = {
      showNavigation: "data-show-navigation",
    };
  }

  connectedCallback() {
    this.setupSwiper();
  }

  disconnectedCallback() {
    this.swiperInstance?.destroy();
  }

  attributeChangedCallback(name, _oldValue, newValue) {
    // when a block is selected, the selected block is shown
    switch (name) {
      case "data-active-block-index":
        if (!newValue) break;
        this.showBlockSlide(newValue);
    }
  }

  setupSwiper() {
    this.swiperContainer = this.querySelector(this.selectors.swiper);
    this.swiperSlides = this.swiperContainer.querySelectorAll(
      this.selectors.swiperSlide
    );

    // Don't loop or show navigation when only one original slide
    const swiperSlideCount = this.swiperSlides.length;
    this.enableSwiperLoop = swiperSlideCount > 1;
    this.swiperContainer.parentElement.setAttribute(
      this.attrs.showNavigation,
      this.enableSwiperLoop
    );

    import(flu.chunks.swiper).then(({ Swiper, Navigation }) => {
      this.swiperInstance = new Swiper(this.swiperContainer, {
        modules: [Navigation],
        grabCursor: true,
        spaceBetween: 12,
        slidesPerView: 1,
        watchSlidesProgress: true,
        loop: this.enableSwiperLoop,
        navigation: {
          nextEl: this.querySelector(this.selectors.swiperNextEl),
          prevEl: this.querySelector(this.selectors.swiperPrevEl),
        },
        breakpoints: {
          720: {
            spaceBetween: 16,
          },
        },
        on: {
          afterInit: () => {
            this.swiperSlides = this.swiperContainer.querySelectorAll(
              this.selectors.swiperSlide
            );
            this.handleSlideChanged();
          },
          transitionEnd: () => this.handleSlideChanged(),
        },
      });
    });
  }

  /**
   * Sets inactive slides as 'inert' to improve keyboard accessibility.
   */
  handleSlideChanged() {
    this.swiperSlides.forEach(slide => {
      slide.toggleAttribute(
        "inert",
        !slide.classList.contains("swiper-slide-active")
      );
    });
  }

  /**
   * Shows the slide corresponding with the slide index. Used for the theme editor.
   * @param {String} slideIndex - The slide index for the selected block.
   */
  showBlockSlide(slideIndex) {
    if (this.swiperInstance) {
      this.swiperInstance.slideToLoop(slideIndex);
    }
  }
}

if (!customElements.get("products-slider")) {
  customElements.define("products-slider", ProductsSlider);
}
